import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3883904f&lang=scss&scoped=true"

import exportComponent from "D:\\works\\Company项目\\桃小黑\\heitao-im\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3883904f"]])

export default __exports__